import React from 'react';
import { AsSelect } from '@adserve/adserve-react-components';
import { useLiveContentDayReportContext } from './contexts/LiveContentDayReportContext';

const labelStyle = {
    display: 'block',
    textAlign: 'left',
    fontSize: 12,
    color: '#414141',
    marginBottom: 3
};

const selectStyle = {
    boxSizing: 'border-box',
    width: '100%',
    height: 40,
    outline: 'none',
    autoComplete: 'off',
    padding: '0 12px',
    fontSize: 15,
    letterSpacing: -0.3,
    fontWeight: 500,
    fontFamily: 'Roboto',
    color: '#414141'
};

const InnerSelectLog = (props) => {
    const onChange = (ev) => props.handleSelectLog(ev.target.value);

    return (
        <AsSelect
            id='log-select'
            values={props.logsList}
            value={props.selectedLog?.id}
            onChange={onChange}
            title={window.translate('Logs')}
            placeholder={window.translate('Select a Log...')}
            labelStyle={labelStyle}
            inputStyle={selectStyle}
            disableTooltip={true}
        />
    );
};

const CachedSelectLog = React.memo(InnerSelectLog);

export const SelectLog = () => {
    const { logsList, selectedLog, handleSelectLog } = useLiveContentDayReportContext();
console.log('logsList',logsList)
    return (
        <CachedSelectLog
            logsList={logsList}
            selectedLog={selectedLog}
            handleSelectLog={handleSelectLog}
        />
    );
};
